const steelOrthoticsSizeCalculator = function(skateSizes, skateWidthOptions) {
    return {
        result: "",
        selectedSize: null,
        selectedWidth: null,
        skateSizes: skateSizes,
        skateWidths: skateWidthOptions,
        filterSkateWidths(el) {
            // filter skate width options based on size selected
            const selectedSizeObj = this.skateSizes.filter((size) => size.size == this.selectedSize);
            const widths = selectedSizeObj[0].widths;
            const widthOptions = el.options;

            for (var i = 0; i < widthOptions.length; i++) {
                if (widths.includes(widthOptions[i].value)) {
                    widthOptions[i].disabled = false;
                } else {
                    if (widthOptions[i].disabled == false) {
                        widthOptions[i].disabled = true;
                        widthOptions[i].selected = false;
                    }
                }
            }

            this.selectedWidth = el.value;
        },
        calculateSize(size, width, noResult, noWidth, noSize) {
            if (size && width != "") {
                const filteredSize = this.skateSizes.filter(function(e){
                    return e.size == size;
                });

                const widths = filteredSize[0].widths;
                const widthIndex = widths.findIndex(x => x == width);
                let sizeResult = filteredSize[0].steel[widthIndex];
                
                if (sizeResult.includes("/")) {
                    let sizeResult =  filteredSize[0].steel[widthIndex].split("/");
                    let steelSize = sizeResult[0];
                    let steelMeasurement = sizeResult[1];
                    this.result = `${steelSize.bold()}/${steelMeasurement}`;
                } else {
                    this.result = sizeResult;
                }
            }

            if (size == null && width == null) {
                this.result = noResult;
            }
            
            if (size && width == "") {
                this.result = noWidth;
            }
            
            if (size == null && width) {
                this.result = noSize;
            }
        }
    }
}